import {Button, Col, Form, Input, Row, Alert} from "antd";
import React, {useRef, useState} from "react";
import "./formRegister.scss";
import {IoCheckmarkCircle} from "react-icons/io5";
import {LoginProviders} from "../loginProviders/loginProviders";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {userService} from "../../services/user.service";
import moment from "moment";


const FormRegister = ({handleCancel,handleFormSubmit, textRegister= null, title= "", msg, setMsg, isFormModal = false}) => {
    const [form] = Form.useForm();
    const [user, setUser] = useState({
        email: "",
        password: "",
    });
    const [validatePassword, setValidatePassword] = useState(false);
    const oneCharacter = useRef();
    const oneN = useRef();
    const oneLetterL = useRef();
    const oneLetterU = useRef();
    const min8Characters = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const accountSettings = useSelector((state) => state.accountSettings);
    const { referralToken } = useParams();

    const onSubmit = async () => {
        setIsLoading(true)

        //if (accountSettings.activateRegistration) {
        const data = {
            ...user,
            firstName: " ",
            CompanyId: process.env.REACT_APP_COMPANY,
            CountryStateTypeId: "1",
            MaritalStatusTypeId: "1",
            NationalityTypeId: "1",
            PostalCode: "",
            RFC: "",
            birthday: moment(),
            ReferralToken: referralToken,
            gender: "F",
            middleName: " ",
            lastName: " ",
            mobileConfirm: "",
            mobile: ""
        }
        const result = await userService.register(data);
        if (result.success) {
            handleFormSubmit(true, "Tu registro fue exitoso, confirma tu correo electrónico.", "Revisa tu bandeja de correo", true, true);
            setIsLoading(false);
        } else {
            handleFormSubmit(true, "Tu registro tuvo un problema", result.msg, false, true);
            setIsLoading(false);
        }
        //}
    };

    const handleInputValue = (e) => setUser({ ...user, [e.target.name]: e.target.value });

    const handlePassword = (e) => {
        const oneLetterUppercase = /.*[A-Z].*/;
        const oneLetterLowercase = /.*[a-z].*/;
        const oneNumber = /.*[0-9].*/;
        const oneSpecialCharacter =
            /(.*[!@#$%\^&*(){}[\]<>?/|-]+|.*[!@#$%\^&*(){}[\]<>?/|\-]+)/;

        const noSpace = e.target.value.replace(/ /g, "");

        if (String(noSpace).length >= 8)
            min8Characters.current.className = "success";
        else min8Characters.current.className = "";

        if (oneLetterUppercase.test(noSpace))
            oneLetterU.current.className = "success";
        else oneLetterU.current.className = "";

        if (oneLetterLowercase.test(noSpace))
            oneLetterL.current.className = "success";
        else oneLetterL.current.className = "";

        if (oneNumber.test(noSpace)) oneN.current.className = "success";
        else oneN.current.className = "";

        if (oneSpecialCharacter.test(noSpace))
            oneCharacter.current.className = "success";
        else oneCharacter.current.className = "";

       // form.setFieldValue("password", noSpace);
        setUser({ ...user, [e.target.name]: noSpace });
    };

    return (
        <Form
            form={form}
            className="form-light small"
            onFinish={onSubmit}
            layout="vertical"
        >
            <Row gutter={[8,8]}>
                <Col span={24}>
                    {
                        <>
                            <h4>{title}</h4>
                            <p className={"text-informative"}>Ingresa tus datos para acceder a nuestro sitio</p>
                            {(textRegister) ? textRegister : ""}
                        </>
                    }
                </Col>
                {msg !== "" && (
          <Col xs={24} style={{ marginTop: "1rem" }}>
            <Alert message={msg} type="warning" showIcon closable />
          </Col>
        )}
                <Col xs={24}>
                    <Form.Item
                        label="Tu correo"
                        name="email"
                        htmlFor={"email"}
                        rules={[
                            { required: true, message: "*Campo requerido" },
                            { type: "email", message: "No es un formato de correo válido" },
                        ]}
                        onChange={handleInputValue}
                    >
                        <Input size="large" name={"email"} />
                    </Form.Item>
                </Col>
                <Col sm={12} xs={24}>
                    <Form.Item
                        label={"Contraseña"}
                        htmlFor={"password"}
                        name={"password"}
                        rules={[
                            {
                                required: true,
                                message: "*Campo requerido",
                            },
                            {
                                min: 8,
                                message: "",
                            },
                            {
                                pattern: new RegExp(/.*[A-Z].*/),
                                message: "",
                            },
                            {
                                pattern: new RegExp(/.*[a-z].*/),
                                message: "",
                            },
                            {
                                pattern: new RegExp(/.*[0-9].*/),
                                message: "",
                            },
                            {
                                pattern: new RegExp(
                                    /(.*[!@#$%\^&*(){}[\]<>?/|-]+|.*[!@#$%\^&*(){}[\]<>?/|\-]+)/
                                ),
                                message: "",
                            },
                        ]}
                        onChange={handlePassword}
                    >
                        <Input.Password
                            name={"password"}
                            size={"large"}
                            onBlur={() => setValidatePassword(false)}
                            onFocus={() => setValidatePassword(true)}
                        />
                    </Form.Item>
                    <div
                        className={`msg-password`}
                    >
                        <ul className={"msg-password__list"}>
                            <li>
                                <span ref={min8Characters}>
                                  <IoCheckmarkCircle />
                                </span>
                                Mínimo 8 carácteres
                            </li>
                            <li>
                                <span ref={oneLetterU}>
                                  <IoCheckmarkCircle />
                                </span>
                                1 letra mayúscula
                            </li>
                            <li>
                                <span ref={oneLetterL}>
                                  <IoCheckmarkCircle />
                                </span>
                                1 letra minúscula
                            </li>
                            <li>
                                <span ref={oneN}>
                                  <IoCheckmarkCircle />
                                </span>
                                1 número
                            </li>
                            <li>
                                <span ref={oneCharacter}>
                                  <IoCheckmarkCircle />
                                </span>
                                1 carácter especial
                            </li>
                        </ul>
                    </div>
                </Col>
                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                    <Form.Item
                        label={"Confirma tu contraseña"}
                        name={"confirmPassword"}
                        dependencies={["password"]}
                        rules={[
                            {
                                required: true,
                                message: "",
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("password") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error("¡Las contraseñas no coinciden!")
                                    );
                                },
                            }),
                        ]}
                    >
                        <Input.Password name={"confirmPassword"} size={"large"} />
                    </Form.Item>
                </Col>
                <div className="form-light__footer">
                    {(isFormModal) && (
                        <Button type="default" onClick={handleCancel} block={true} disabled={isLoading}>
                            Cerrar
                        </Button>
                    )
                    }
                    <Button
                        htmlType="submit"
                        type="primary"
                        block={true}
                        loading={isLoading}
                    >
                        Registrarse
                    </Button>
                </div>
                <Col xs={24}>
                    <LoginProviders textDivider={"O registrarse con"} isLogin={false} setMsg={setMsg} />
                </Col>
            </Row>
        </Form>
    );
}

export default FormRegister;